import type { ID } from '@octopus-do/octopus-project-core'

import type { Workspace, WorkspaceItem } from '../types'

export const findFolder = (
  id: ID,
  workspaceId: ID,
  dashboard: Workspace[]
): WorkspaceItem | null => {
  const workspace = dashboard.find((w) => w.id === workspaceId)
  const folder = workspace?.folders?.find((f) => f.id === id)

  return folder || null
}
